import httpClient from "./httpClient";

export const downloadFile = async (url: string, filename: string, filters: any = null, queryParams: any = null) => {
  try {
    // Build URL with query parameters if provided
    let finalUrl = url;
    if (queryParams) {
      const params = new URLSearchParams();
      Object.keys(queryParams).forEach(key => {
        if (queryParams[key] !== null && queryParams[key] !== undefined) {
          params.append(key, queryParams[key].toString());
        }
      });
      const queryString = params.toString();
      if (queryString) {
        finalUrl += `?${queryString}`;
      }
    }

    const response = await httpClient.post(finalUrl, filters, {
      responseType: "blob",
    });
    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    window.URL.revokeObjectURL(link.href);
  } catch (error) {
    console.error("File download error:", error);
  }
};